import { Badge } from '@/components/ui/badge';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { useCpvData } from '@/hooks/useCpvBatch';
import { cn } from '@/lib/utils';

interface CpvBadgeProps {
  code: string;
  showPrefix?: boolean;
  className?: string;
}

export default function CpvBadge({ code, showPrefix = false, className }: CpvBadgeProps) {
  const { data: cpvData, isLoading } = useCpvData(code);

  const badgeContent = (
    <Badge 
      variant="secondary" 
      className={cn(
        "text-xs cursor-help transition-colors hover:bg-secondary/80",
        isLoading && "animate-pulse",
        className
      )}
    >
      {showPrefix && "CPV: "}{code}
    </Badge>
  );

  if (isLoading || (!cpvData?.description && !cpvData?.category)) {
    return badgeContent;
  }

  return (
    <Tooltip delayDuration={200}>
      <TooltipTrigger asChild>
        {badgeContent}
      </TooltipTrigger>
      <TooltipContent 
        side="top" 
        className="max-w-xs text-center"
      >
        <div className="space-y-1">
          <p className="font-medium">{code}</p>
          {cpvData.description && (
            <p className="text-sm">{cpvData.description}</p>
          )}
          {cpvData.category && (
            <p className="text-xs text-muted-foreground">Categoria: {cpvData.category}</p>
          )}
        </div>
      </TooltipContent>
    </Tooltip>
  );
}
